import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Card, Divider, Grid, IconButton, Typography, } from '@material-ui/core';
import SearchIcon from '../../icons/Search';
import Scrollbar from '../../components/Scrollbar';
import { PaginationResult } from '../../types/paginationResult';
import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import { Airfield } from '../../models/Airfield';
import TableRowsLoaderVariant from '../../components/TableRowsLoaderVariant';
import verifiedShield from '../../images/verified_Shield.png';


interface AirfieldsPublicListProps {
	airfields: PaginationResult<Airfield>;
	recordLimit: number;
	isLoading: boolean
}


const AirfieldMobileListCard: FC<AirfieldsPublicListProps> = (props) => {
	const { t } = useTranslation();

	const { airfields, recordLimit, isLoading } = props;



	return (
		<Card sx={{ m: 2 }}>
			<Scrollbar>
				{isLoading ?
					(<TableRowsLoaderVariant rowsNum={recordLimit} height={150} hasDivider={true} />) : (
						<>
							<Box sx={{ minWidth: 250 }}>
								{airfields?.items.map((airfield) => (
									<>
										<Grid container >
											<Grid item xs={10}>
												<Box sx={{ flexDirection: 'row', m: 2 }}>
													<Typography
														color="textPrimary"
														variant="body1">
														<strong>{airfield.name}</strong>
													</Typography>
													<Typography
														color="textSecondary"
														variant="body1">
														<strong>ICAO</strong>: {airfield.icaoCode}
													</Typography>
													<Typography
														color="textSecondary"
														variant="body1">
														<strong>{t("MUNICIPALITY_SHORT")}</strong>: {airfield.municipality}
													</Typography>
													<Typography
														color="textSecondary"
														variant="body1">
														<strong>Prov</strong>: {airfield.province}
													</Typography>
													<Typography
														color="textSecondary"
														variant="body1">
														<strong>Reg</strong>: {airfield.region}
													</Typography>

												</Box>
											</Grid>
											<Grid item xs={2} sx={{ mt: 7 }}>
												<Box sx={{
													display: 'flex',
													justifyContent: 'flex-end',
													mr: 3.5
												}}>

													{airfield.isRegistred &&
														<Box sx={{ mt: 1 }}
															component="img"
															src={verifiedShield}
															height={20}
														/>
													}
													<Tooltip title={t('DETAILS') || ''} aria-label={t('DETAILS') || ''}>
														<IconButton
															component={RouterLink}
															to={`details?airfieldId=${airfield.id}`}
														>
															<SearchIcon fontSize="small" />
														</IconButton>
													</Tooltip>

												</Box>
											</Grid>

										</Grid>
										<Divider />
									</>
								))}

							</Box>
						</>
					)
				}




			</Scrollbar>
		</Card>
	);
};

export default AirfieldMobileListCard;
